module.exports = __webpack_public_path__ + "static/media/greateVictory-4.0ea3570a.png";